function mapEstimatedDelivery(data, locale) {
    var ref, ref1, ref2, ref3;
    var ref4;
    return {
        deliveryDate: (data === null || data === void 0 ? void 0 : (ref = data.estimatedDeliveryBySkus) === null || ref === void 0 ? void 0 : ref.deliveryDate) ? new Date(data.estimatedDeliveryBySkus.deliveryDate) : undefined,
        shippingMethodDescription: (ref4 = (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data.estimatedDeliveryBySkus) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.shippingMethodDescription) === null || ref2 === void 0 ? void 0 : ref2.find((description)=>description.locale === locale || description.locale === locale.substr(0, 2)
        )) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref4 !== void 0 ? ref4 : ''
    };
}

export { mapEstimatedDelivery };
//# sourceMappingURL=estimated-delivery.js.map
